import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";
import {
  Create,
  Datagrid,
  DateField,
  Edit,
  FunctionField,
  List,
  SimpleForm,
  TextField,
  TextInput,
  useTranslate,
} from "react-admin";
import { Link } from "react-router-dom";

export const InstallationList = (props) => {
  const translate = useTranslate();

  return (
    <List {...props} sort={{ field: "modified", order: "DESC" }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="userId" />
        <FunctionField
          label="App"
          render={(record) =>
            record && record.appId && record.appId.includes("mdm")
              ? "MDM"
              : "PUBLIC"
          }
        />
        <TextField source="userType" />
        <DateField source="modified" showTime />
        <TextField source="deviceType" />
        <TextField source="deviceToken" />
        <TextField source="appVersion" />
      </Datagrid>
    </List>
  );
};

const CustomForm = (props) => {
  const translate = useTranslate();
  return (
    <div className="w-100">
      <div className="d-flex flex-wrap">
        <div className="col-12 col-sm-6">
          <TextInput source="version" fullWidth />
        </div>
        <div className="col-12 col-sm-6">
          <TextInput source="buildNumber" fullWidth />
        </div>
      </div>
    </div>
  );
};

export const AppVersionCreate = (props: any) => {
  const translate = useTranslate();
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <Link to="/AppVersions" className="text-decoration-none">
          <ArrowBackIcon /> {translate("button.back")}
        </Link>
        <h3>{translate("appversion.create")}</h3>
        <b></b>
      </div>
      <Create {...props}>
        <SimpleForm redirect="/AppVersions">
          <CustomForm />
        </SimpleForm>
      </Create>
    </div>
  );
};

export const AppVersionEdit = (props: any) => {
  const translate = useTranslate();
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <Link to="/Parametres" className="text-decoration-none">
          <ArrowBackIcon /> {translate("button.back")}
        </Link>
        <h3>{translate("guide.edit")}</h3>
        <b></b>
      </div>
      <Edit {...props}>
        <SimpleForm>
          <CustomForm />
        </SimpleForm>
      </Edit>
    </div>
  );
};
